import BaseResource from './BaseResource'

export default class OperationOptions extends BaseResource {
  static endpoint = '/api/v1/operationOptions' ///profile
}
